export default __webpack_public_path__ + "static/media/droopy1943.743dd872.mp4";